import {
  MapPin,
  Bell,
  Bookmark,
  CalendarClock,
  BadgeCheck,
  Building2,
  ClipboardList,
  Contact,
  CreditCard,
  FileSignature,
  FileText,
  Flag,
  Gauge,
  Heart,
  LayoutDashboard,
  MessageSquare,
  Send,
  Settings,
  ShieldCheck,
  Tag,
  UserCog,
  UserRound,
  Users,
  Unlock,
  DollarSign,
  History,
  Star,
  CircleParking,
  ReceiptText,
  MessagesSquare,
  Layers3,
  SlidersHorizontal,
  BarChart3,
  GitCompareArrows,
  LifeBuoy,
  Globe,
} from "lucide-react";
import type { NavItem } from "@/components/DashboardShell";

export const CUSTOMER_NAV: NavItem[] = [
  { to: "/customer/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/customer/profile", label: "My Profile", icon: UserRound },
  { to: "/customer/favourites", label: "Favourite Listings", icon: Heart },
  { to: "/customer/recently-viewed", label: "Recently Viewed", icon: History },
  { to: "/customer/saved-searches", label: "Saved Searches", icon: Bookmark },
  { to: "/compare", label: "Compare Properties", icon: GitCompareArrows },
  { to: "/customer/enquiries", label: "My Enquiries", icon: Send },
  { to: "/customer/contact-unlocks", label: "Contact Requests", icon: Unlock },
  { to: "/customer/visit-requests", label: "Visit Requests", icon: CalendarClock },
  { to: "/customer/reviews", label: "My Reviews", icon: Star },
  { to: "/customer/reports", label: "My Reports", icon: Flag },
  { to: "/customer/verification", label: "Verification", icon: BadgeCheck },
  { to: "/customer/subscriptions", label: "Subscriptions", icon: CreditCard },
  { to: "/customer/notifications", label: "Notifications", icon: Bell },
  { to: "/support", label: "Support", icon: LifeBuoy },
  { to: "/customer/settings", label: "Settings", icon: Settings },
];

export const PARTNER_NAV: NavItem[] = [
  { to: "/partner/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/partner/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/partner/services", label: "My Services", icon: Layers3 },
  { to: "/partner/services/add", label: "Add Service", icon: Tag },
  { to: "/partner/listings", label: "My Listings", icon: Building2 },
  { to: "/partner/listings/new", label: "Create Listing", icon: Tag },
  { to: "/partner/properties", label: "Properties", icon: Building2 },
  { to: "/partner/parking", label: "Parking", icon: CircleParking },
  { to: "/partner/billing", label: "Invoices", icon: ReceiptText },
  { to: "/partner/invoices", label: "Customer Invoices", icon: ReceiptText },
  { to: "/partner/messages", label: "Messages", icon: MessagesSquare },
  { to: "/partner/message-templates", label: "Message Templates", icon: FileText },
  { to: "/partner/enquiries", label: "Enquiries", icon: MessageSquare },
  { to: "/partner/contact-requests", label: "Contact Requests", icon: Contact },
  { to: "/partner/visit-requests", label: "Visit Requests", icon: CalendarClock },
  { to: "/partner/reviews", label: "Reviews & Ratings", icon: Star },
  { to: "/partner/subscription", label: "My Subscription", icon: CreditCard },
  { to: "/partner/verification", label: "Verification", icon: BadgeCheck },
  { to: "/partner/agreements", label: "Agreements", icon: FileSignature },
  { to: "/partner/notifications", label: "Notifications", icon: Bell },
  { to: "/support", label: "Support", icon: LifeBuoy },
  { to: "/partner/profile", label: "Profile", icon: UserRound },
];

export const ADMIN_NAV: NavItem[] = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/listings/pending", label: "Pending Listings", icon: ClipboardList },
  { to: "/admin/listings/approved", label: "Approved Listings", icon: BadgeCheck },
  { to: "/admin/listings/rejected", label: "Rejected Listings", icon: Flag },
  { to: "/admin/properties", label: "Properties", icon: Building2 },
  { to: "/admin/parking", label: "Parking", icon: CircleParking },
  { to: "/admin/service-requests", label: "Service Requests", icon: Layers3 },
  { to: "/admin/partners", label: "Partners", icon: Users },
  { to: "/admin/customers", label: "Customers", icon: UserRound },
  { to: "/admin/verifications/pending", label: "Pending Verification", icon: ShieldCheck },
  { to: "/admin/verifications/approved", label: "Verified Approved", icon: BadgeCheck },
  { to: "/admin/verifications/rejected", label: "Verification Rejected", icon: Flag },
  { to: "/admin/verifications/changes", label: "Changes Requested", icon: ClipboardList },
  { to: "/admin/agreements", label: "Agreements", icon: FileSignature },
  { to: "/admin/complaints", label: "Complaints", icon: Flag },
  { to: "/admin/reviews", label: "Reviews", icon: Star },
  { to: "/admin/user-reports", label: "Reports", icon: Flag },
  { to: "/admin/reports", label: "Analytics Reports", icon: FileText },
  { to: "/admin/support", label: "Support Tickets", icon: LifeBuoy },
  { to: "/admin/notifications", label: "Notifications", icon: Bell },
];

export const SUPER_ADMIN_NAV: NavItem[] = [
  { to: "/super-admin/dashboard", label: "Dashboard", icon: Gauge },
  { to: "/super-admin/partners", label: "Partners", icon: Star },
  { to: "/super-admin/customers", label: "Customers", icon: Users },
  { to: "/super-admin/listings", label: "Listings", icon: Building2 },
  { to: "/super-admin/services", label: "Services", icon: Layers3 },
  { to: "/super-admin/service-plans", label: "Subscription Plans", icon: SlidersHorizontal },
  { to: "/super-admin/agreements", label: "Agreements", icon: FileSignature },
  { to: "/super-admin/verification-rules", label: "Verification Rules", icon: ShieldCheck },
  { to: "/super-admin/cities", label: "City Management", icon: MapPin },
  { to: "/super-admin/languages", label: "Languages", icon: Globe },
  { to: "/super-admin/settings", label: "System Settings", icon: Settings },
  { to: "/super-admin/maintenance", label: "System Maintenance", icon: SlidersHorizontal },
  { to: "/super-admin/announcements", label: "Announcements", icon: Bell },
  { to: "/super-admin/announcement-preview", label: "Announcement Preview", icon: Bell },
  { to: "/super-admin/reports", label: "Reports", icon: FileText },
  { to: "/super-admin/activity-logs", label: "Activity Logs", icon: ClipboardList },
  { to: "/super-admin/notifications", label: "Notifications", icon: Bell },
];

// re-export a stub so imports resolve
export const _placeholderIcon = ClipboardList;
